import LogIn from './pages/login';
import ForgotPassword from './pages/forgot-password';
import ResetPassword from './pages/forgot-password/reset-password';
import AccountConfirmation from './pages/signup-confirm/page';

import {
  RouteObject,
  createBrowserRouter,
  RouterProvider,
  Outlet,
  Navigate,
} from 'react-router-dom';

// DashBoard
import DashBoard from './pages/dashboard';

// Customers
import Customers from './pages/customers';

// Layouts
import UserIsAuthenticatedGuard from './components/AuthProvider';
import NavBarsLayout from './layouts/NavBarsLayout';
import TeamProvider from './components/TeamProvider';
import Vendors from './pages/vendors';
import Items from './pages/items';
import Orders from './pages/orders';
import Invoices from './pages/invoices';
import PurchaseOrders from './pages/purchaseOrders';
import PackingSlips from './pages/packingSlips';
import PaymentReceived from './pages/paymentReceived';
import PayVendor from './pages/payVendor';
import Reports from './pages/reports';
import SalesTaxReport from './pages/reports/SalesTaxReport';
import StatementReport from './pages/reports/StatementReport';
import AccountsPayableReport from './pages/reports/AccountsPayableReport';
import AccountsReceivableReport from './pages/reports/AccountsReceivableReport';
import CustomerReport from './pages/reports/CustomerReport';
import VendorReport from './pages/reports/VendorReport';
import SalesOrderReport from './pages/reports/SalesOrderReport';

// Help
import Help from './pages/help';
import HelpArticle from './pages/help/HelpArticle';

const routes: RouteObject[] = [
  {
    errorElement: <div>404 Not Found</div>,
    children: [
      // REDIRECT ROUTES
      {
        index: true,
        element: <Navigate to="login" replace={true} />,
      },

      // UNPROTECTED ROUTES
      {
        path: '/login',
        element: <LogIn />,
      },
      {
        path: '/forgot-password',
        element: <ForgotPassword />,
      },
      {
        path: '/forgot-password/reset-password',
        element: <ResetPassword />,
      },
      {
        path: '/signup-confirm',
        element: <AccountConfirmation />,
      },
      // PROTECTED ROUTES
      {
        element: (
          <UserIsAuthenticatedGuard>
            <Outlet />
          </UserIsAuthenticatedGuard>
        ),
        children: [
          {
            path: '/:team',
            element: (
              // <CustomerExistsGuard>
              //   <CurrentUserLoaderGuard>
              <TeamProvider>
                <NavBarsLayout>
                  <Outlet />
                </NavBarsLayout>
              </TeamProvider>
              //   </CurrentUserLoaderGuard>
              // </CustomerExistsGuard>
            ),
            children: [
              {
                index: true,
                element: <Navigate to="dashboard" replace={true} />,
              },
              {
                path: '/:team/dashboard',
                element: <DashBoard />,
              },
              {
                path: '/:team/customers',
                element: <Customers />,
              },
              {
                path: '/:team/vendors',
                element: <Vendors />,
              },
              {
                path: '/:team/items',
                element: <Items />,
              },
              {
                path: '/:team/orders',
                element: <Orders />,
              },
              {
                path: '/:team/purchaseorders',
                element: <PurchaseOrders />,
              },
              {
                path: '/:team/invoices',
                element: <Invoices />,
              },
              {
                path: '/:team/packing-slips',
                element: <PackingSlips />,
              },
              {
                path: '/:team/payment-received',
                element: <PaymentReceived />,
              },
              {
                path: '/:team/pay-vendor',
                element: <PayVendor />,
              },
              {
                path: '/:team/reports',
                element: <Reports />,
              },
              {
                path: '/:team/reports/sales-tax',
                element: <SalesTaxReport />,
              },
              {
                path: '/:team/reports/statement',
                element: <StatementReport />,
              },
              {
                path: '/:team/reports/accounts-payable',
                element: <AccountsPayableReport />,
              },
              {
                path: '/:team/reports/accounts-receivable',
                element: <AccountsReceivableReport />,
              },
              {
                path: '/:team/reports/customer',
                element: <CustomerReport />,
              },
              {
                path: '/:team/reports/vendor',
                element: <VendorReport />,
              },
              {
                path: '/:team/reports/sales-order',
                element: <SalesOrderReport />,
              },
              {
                path: '/:team/help',
                element: <Help />,
              },
              {
                path: '/:team/help/:articleId',
                element: <HelpArticle />,
              },
            ],
          },
        ],
      },
    ],
  },
];

const router = createBrowserRouter(routes);

export default function Router() {
  return <RouterProvider router={router} />;
}
